function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#4A4A4A",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.83 19.538l-1.492 1.476h3.89v-3.847l-1.252 1.238-2.888-2.868v-3.498h-1.62v4.16l3.362 3.34zm-5.956-1.016l-1.37-1.355v3.847h3.89l-1.374-1.359 1.88-1.868-1.148-1.13-1.878 1.865zm-3.995-4.48h2.467l-.005-2.694h2.686V8.865h8.308c.826 0 1.495.67 1.495 1.495v11.968c0 .826-.67 1.496-1.495 1.496H11.367c-.826 0-1.496-.67-1.496-1.496l.008-8.286z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.208 8.869h2.693v1.346h-2.693v2.693H9.862v-2.693H7.17V8.87h2.692V6.176h1.346z"
}))));